var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BModal', {
    attrs: {
      "id": "modal-result-recalculate-price-class-booking-".concat(_vm.modalId),
      "title": "Tính giá",
      "title-class": "text-airline font-medium-4 font-weight-bolder",
      "header-class": "px-1 py-50",
      "body-class": "px-50",
      "centered": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.handleShowModal
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('BButton', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(186, 191, 199, 0.15)',
            expression: "'rgba(186, 191, 199, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "center rounded-pill px-2 mr-1",
          attrs: {
            "size": "md",
            "variant": "outline-secondary"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.back')) + " ")]), _c('BButton', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-gradient px-2 px-md-3",
          attrs: {
            "pill": "",
            "disabled": _vm.isEmpty(_vm.arrIndexTripSelectSort)
          },
          on: {
            "click": _vm.submitRecalculatePrice
          }
        }, [_c('span', {
          staticClass: "align-middle"
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.recalculatePrice.title')) + " ")])])];
      }
    }])
  }, [!['VN1A'].includes(_vm.airlineSearch) ? _c('BCard', {
    attrs: {
      "body-class": "py-1 px-50 px-md-1"
    }
  }, [['1G'].includes(_vm.airlineSearch) ? _c('div', {
    staticClass: "fw-700 font-medium-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.combinatePrice')) + " ")]) : _vm._e(), _c('BFormRadioGroup', {
    attrs: {
      "id": "calc-mode",
      "options": _vm.getCalcModeOption,
      "stacked": ""
    },
    model: {
      value: _vm.calcMode,
      callback: function callback($$v) {
        _vm.calcMode = $$v;
      },
      expression: "calcMode"
    }
  })], 1) : _vm._e(), _c('BAlert', {
    staticClass: "mb-75 py-50 px-1 text-center",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_c('span', {
    staticClass: "text-airline font-italic"
  }, [_vm._v(" " + _vm._s(_vm.$t("flight['For Round-trip flights, please select Calculate combined price to get the exact price']")) + " ")])]), _c('BCard', {
    attrs: {
      "body-class": "py-1 px-50 px-md-1"
    }
  }, [_c('div', {
    staticClass: "fw-700 font-medium-2"
  }, [_vm._v(" " + _vm._s(['VN1A'].includes(_vm.airlineSearch) ? 'Hành trình' : _vm.$t('reservation.specialServices.itineraries.title')) + " ")]), _vm.dataTripsToCalcPrice ? _c('div', [_c('BFormCheckboxGroup', {
    attrs: {
      "id": "checkbox-group-trip-calc",
      "stacked": ""
    },
    model: {
      value: _vm.arrIndexTripSelect,
      callback: function callback($$v) {
        _vm.arrIndexTripSelect = $$v;
      },
      expression: "arrIndexTripSelect"
    }
  }, _vm._l(_vm.dataTripsToCalcPrice, function (trip, indexTrip) {
    return _c('div', {
      key: indexTrip,
      staticClass: "d-flex-column my-75"
    }, [_c('BFormCheckbox', {
      attrs: {
        "value": indexTrip,
        "disabled": ['VN1A'].includes(_vm.airlineSearch)
      }
    }, _vm._l(trip, function (segment, indexSegment) {
      return _c('div', {
        key: indexSegment
      }, [_c('span', {
        staticClass: "text-dark fw-700 pl-md-25"
      }, [_vm._v(" " + _vm._s(_vm.getSortTripBySegment(segment, true)) + " ")])]);
    }), 0)], 1);
  }), 0)], 1) : _vm._e()]), !_vm.isEmpty(_vm.dataAddMoreFlight) ? _c('BCard', {
    attrs: {
      "body-class": "py-1 px-50 px-md-1"
    }
  }, [_c('div', {
    staticClass: "fw-700 font-medium-2"
  }, [_vm._v(" Hành trình thêm ")]), _c('BFormCheckboxGroup', {
    attrs: {
      "id": "checkbox-group-trip-calc",
      "stacked": ""
    },
    model: {
      value: _vm.arrIndexAddMoreTripSelect,
      callback: function callback($$v) {
        _vm.arrIndexAddMoreTripSelect = $$v;
      },
      expression: "arrIndexAddMoreTripSelect"
    }
  }, _vm._l(_vm.dataAddMoreFlight, function (trip, indexTrip) {
    return _c('div', {
      key: trip.tripUuid,
      staticClass: "d-flex-column my-75"
    }, [_c('BFormCheckbox', {
      attrs: {
        "value": indexTrip,
        "disabled": ""
      }
    }, _vm._l(trip.segments, function (segment, indexSegment) {
      return _c('div', {
        key: indexSegment
      }, [_c('span', {
        staticClass: "text-dark fw-700 pl-md-25"
      }, [_vm._v(" " + _vm._s(_vm.getSortTripBySegment(segment, true)) + " ")])]);
    }), 0)], 1);
  }), 0)], 1) : _vm._e(), _c('BCard', {
    attrs: {
      "body-class": "py-1 px-50 px-md-1"
    }
  }, [_c('div', {
    staticClass: "fw-700 font-medium-1 mb-25"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.numPassenger')) + " ")]), _c('BRow', {
    staticClass: "justify-content-start"
  }, _vm._l(_vm.countPaxs, function (pax, indexPax) {
    return _c('BCol', {
      key: indexPax,
      attrs: {
        "cols": "auto"
      }
    }, [pax.count > 0 ? _c('span', {
      class: indexPax !== _vm.countPaxs.length - 1 ? 'mr-1' : ''
    }, [_c('span', {
      staticClass: "font-small-4"
    }, [_vm._v(_vm._s(pax.title) + ": ")]), _c('span', {
      staticClass: "text-danger fw-700 font-medium-3"
    }, [_vm._v(_vm._s(pax.count))])]) : _vm._e()]);
  }), 1)], 1), ['1G', 'VN1A'].includes(_vm.airlineSearch) ? _c('b-card', {
    attrs: {
      "body-class": "py-75 py-lg-1"
    }
  }, [['VN1A'].includes(_vm.airlineSearch) ? _c('b-row', {
    staticClass: "flex-wrap"
  }, [_c('b-col', {
    staticClass: "px-50"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('flight.fareType'),
      "label-for": "fareType"
    }
  }, [_c('b-form-select', {
    staticClass: "fw-700 text-body",
    attrs: {
      "id": "fareType"
    },
    model: {
      value: _vm.fareType,
      callback: function callback($$v) {
        _vm.fareType = $$v;
      },
      expression: "fareType"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.default')) + " ")]), _vm._l(_vm.fareTypeOptions, function (item) {
    return _c('b-form-select-option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("flight.searchClass.".concat(item))) + " ")]);
  })], 2)], 1)], 1), _c('b-col', {
    staticClass: "px-50"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('flight.currency'),
      "label-for": "currency"
    }
  }, [_c('b-form-select', {
    staticClass: "fw-700 text-body",
    attrs: {
      "id": "currency",
      "value": _vm.currency
    },
    on: {
      "change": function change(val) {
        return _this.$store.dispatch('app-flight-v2/setClassBookingCurrency', val);
      }
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "VND"
    }
  }, [_vm._v(" VND ")]), _c('b-form-select-option', {
    attrs: {
      "value": "USD"
    }
  }, [_vm._v(" USD ")])], 1)], 1)], 1)], 1) : _vm._e(), ['VN1A'].includes(_vm.airlineSearch) ? _c('div', {
    staticClass: "margin-checkbox-label d-flex-center justify-content-around gap-2 text-center mb-50"
  }, [_c('b-form-checkbox', {
    staticClass: "custom-control-warning",
    attrs: {
      "name": "retain-checkbox"
    },
    model: {
      value: _vm.keepGroup,
      callback: function callback($$v) {
        _vm.keepGroup = $$v;
      },
      expression: "keepGroup"
    }
  }, [_c('span', {
    staticClass: "font-medium-2 font-weight-bolder"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.keepClass')) + " ")])])], 1) : _vm._e(), _c('div', {
    staticClass: "margin-checkbox-label d-flex-center justify-content-around gap-2 text-center"
  }, [_c('b-form-checkbox', {
    staticClass: "custom-control-warning",
    attrs: {
      "name": "retain-checkbox"
    },
    model: {
      value: _vm.isBargainFinder,
      callback: function callback($$v) {
        _vm.isBargainFinder = $$v;
      },
      expression: "isBargainFinder"
    }
  }, [_c('span', {
    staticClass: "font-medium-2 font-weight-bolder"
  }, [_vm._v(" " + _vm._s(_vm.$t('reservation.bargainFinder')) + " ")])])], 1), ['VN1A'].includes(_vm.airlineSearch) && _vm.isBargainFinder ? _c('b-alert', {
    staticClass: "text-center px-50 py-50 my-50 fw-700 font-medium-1",
    attrs: {
      "variant": "warning",
      "show": ""
    }
  }, [_c('feather-icon', {
    staticClass: "text-warning mr-25",
    staticStyle: {
      "margin-bottom": "3px"
    },
    attrs: {
      "icon": "InfoIcon",
      "size": "21"
    }
  }), _vm._v(" Sau khi tính giá rẻ nhất thành công sẽ tự động đổi hạng vé đã chọn. ")], 1) : _vm._e()], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }